$(function() {
  "use strict";
  var contentSectionSelector = ".page-template-page-single-page";
  var $contentSections = $(contentSectionSelector);
  var $scrolltypeSelector = $('.body-content');
  var scrollLocked = $scrolltypeSelector.hasClass('scroll-type-locked') ? true : false;
  // var $loader = $('#loader');
  // var $countup = $('span.counter');
  var $current_section;
  var $nav = $('.top-bar');
  var speed = 1200;

  var active_class = 'active-section';
  var $mob_enquire = $('.mobile-enquire-button')
  var $enquire_button = $('.enquire-scroll');
  var $home_button = $('.home-button');

  var isMediumUp = window.matchMedia('screen and (min-width: 768px)').matches ? true : false;
  var isSmall = window.matchMedia('screen and (max-width: 767px)').matches ? true : false;
  
/* IF DIABLING SCROLIFY ON MOBILE or DISABLE ALTOGETHER, COMMENT OUT THE LINE BELOW */

// if($('.body-content').hasClass('scroll-type-natural')) {
//   //_90dl_magellan();
// } else {
//   _90dl_scrollify();
// }

/****** SCROLLIFY *********/


function site_scrollify(media) {

  if (media) {
    _90dl_scrollify();
  }

  window.addEventListener('resize', function() {
    if ($contentSections.length && media == true) {
      _90dl_scrollify();
    }
  })
  
}

let body_classes = document.getElementsByTagName('body')[0].classList;

for (let i=0; i < body_classes.length; i++) {
  switch(body_classes[i]) {

    case "scrollify_mobile":
      site_scrollify(isSmall);
      break;

    case "scrollify_desktop":
      site_scrollify(isMediumUp);
      break;

    case "scrollify_both":
      _90dl_scrollify();
      break;
  }
}

  //extra nav stuff for small 
  $(".next-scroll-icon img").click(function() {
    var next = $(this).closest(".page-section").next().offset().top;
    $("html, body").animate({scrollTop: next},800);
  });
  
  function _90dl_loader(loader, delay) {
    loader.addClass('loaded');
      setTimeout(function(){
        loader.remove();
      }, parseInt(delay));
    }


  function _90dl_scrollify_move() {
    $("[data-scroll-to]").on('click', function(e) {
      var id = parseInt($(this).attr('data-scroll-to'));
      $.scrollify.move(id);
      e.preventDefault();
    });
  }

  function _90dl_scrollify() {
        $.scrollify({
            section : ".page-section",
            sectionName : "section-name",
            easing: "easeOutQuart",
            scrollSpeed: speed,
            offset : 0,
            scrollbars: true,
            standardScrollElements: ".site-footer",
            setHeights: false,
            overflowScroll: true,
            updateHash: false,
            touchScroll:true,
            before:function(index, sections) {
              // _90dl_countup($countup);
              $current_section = $.scrollify.current();
              var $next_section = $(sections[index]);
              $('.page-section').removeClass(active_class);
              $next_section.addClass(active_class);
              $('[data-scroll-to]').removeClass(active_class);
            },
            after:function(index) {
              $('[data-scroll-to=' + index + ']').addClass(active_class);
            },
            afterResize:function() {},
            afterRender:function() {
              $('.page-section').removeClass(active_class);
              $current_section = $.scrollify.current();
              $current_section.addClass(active_class);
              // $('.slick-container').slick();
              // _90dl_loader($loader, 700);
              // _90dl_countup($countup);
            }
        });
        _90dl_scrollify_move();
    }

    function _90dl_countup($element){
      $element.each(function() {
        if($(this).html != '0') {
          $(this).html('0');
        }
        var $this = $(this),
            countTo = $this.attr('data-count');
        $({ countNum: $this.text()}).animate({
          countNum: countTo
        }, { duration: 1300,
            easing:'linear',
            step: function() {
            $this.text(Math.floor(this.countNum));
          },
            complete: function() {
            $this.text(this.countNum);
          }
        });  
      });
    }
});